var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
var StorageService = /** @class */ (function () {
    function StorageService() {
    }
    StorageService.prototype.set = function (key, value) {
        localStorage.setItem(key, value);
    };
    StorageService.prototype.get = function (key) {
        return localStorage.getItem(key);
    };
    StorageService.prototype.getPermissions = function () {
        var res = localStorage.getItem('permission');
        return (res) ? JSON.parse(res) : res;
    };
    StorageService.prototype.setid = function (param) {
        localStorage.setItem('userid', param);
        // console.log(param);
    };
    StorageService.prototype.setRole = function (param) {
        localStorage.setItem('role', param);
        // console.log(param);
    };
    StorageService.prototype.setPermissions = function (param) {
        localStorage.setItem('permission', JSON.stringify(param));
        // console.log(param);
    };
    StorageService.prototype.setCategory = function (category) {
        localStorage.setItem('catId', category);
    };
    StorageService.prototype.getCategory = function () {
        return localStorage.getItem('catId');
    };
    StorageService.prototype.getid = function () {
        var userid = localStorage.getItem('userid');
        // console.log(userid);
        return userid;
    };
    StorageService.prototype.getProfileName = function (key) {
        return localStorage.getItem(key);
    };
    StorageService = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [])
    ], StorageService);
    return StorageService;
}());
export { StorageService };



//////////////////
// WEBPACK FOOTER
// ./src/app/storage.service.ts
// module id = ./src/app/storage.service.ts
// module chunks = main